import ProductDescription from './ProductDescription'

const BSCornMasaFlourProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '016BS',
  IsBroadband: false,
  Size: '',
  Organic: false,
}

export default BSCornMasaFlourProduct
